<div class="container my-5" *ngIf="dataSource && dataSource.data?.length; else noMaps">
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <!-- Colonna Previous Map ID -->
    <ng-container matColumnDef="previousMap">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Previous Map ID</th>
      <td mat-cell *matCellDef="let map">
        {{ map.previous_map_id ? map.previous_map_id : '-' }}
      </td>
    </ng-container>

    <!-- Colonna Major Version -->
    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Version</th>
      <td mat-cell *matCellDef="let map"> {{ map.version }}</td>
    </ng-container>


    <!-- Colonna Created At -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At</th>
      <td mat-cell *matCellDef="let map"> {{ map.created_at | date:'short' }}</td>
    </ng-container>

    <!-- Colonna Major Version -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
      <td mat-cell *matCellDef="let map">
        <mat-chip-list>
          <mat-chip
            [color]="map.status === 'completed' ? 'primary' : map.status === 'draft' ? 'accent' : undefined"
            class="text-white p-1 px-2 rounded"
            selected
          >
            {{ ("pages.ckm-simulations.status." + map.status) | translate }}
          </mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>


    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'generic.action' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button color="primary" class="ml-2"
                [routerLink]="['/ckm-maps/' + element.id]" routerLinkActive="router-link-active">
          <small>{{ 'generic.buttons.go-to-ckm-map' | translate }}</small>
          <mat-icon>forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Header e righe della tabella -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Paginator -->
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #noMaps>
  <div class="no-data text-center">
    <p>Nessuna mappa disponibile.</p>
  </div>
</ng-template>
